import FormField from 'components/FormField';
import { FV } from './share';
import { useTranslate } from '@tolgee/react';
import { useFormikContext } from 'formik';
import { Input } from 'antd';

const nameLimitLength = 50;

function Name({
  policyList,
  editable = true,
}: {
  policyList: NightWatch.Policy[];
  editable?: boolean;
}) {
  const { t } = useTranslate();

  const {
    values: { fallbackPolicyId },
  } = useFormikContext<FV>();

  return (
    <FormField<FV['name']>
      required
      name="name"
      label={t('marketing.策略名称')}
      validate={(value) => {
        if (!value || !value.trim) {
          return t('marketing.请输入策略名称');
        }

        if (policyList.some((_) => _.name === value && _.fallbackPolicyId !== fallbackPolicyId)) {
          return t('marketing.策略名称已存在');
        }

        return undefined;
      }}
    >
      {({ field }) => {
        return (
          <Input
            allowClear
            showCount
            disabled={!editable}
            maxLength={nameLimitLength}
            placeholder={t('marketing.请输入策略名称')}
            {...field}
            style={{ width: '370px' }}
          />
        );
      }}
    </FormField>
  );
}

export default Name;
